function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Button } from '.';
export function ExternalLinkButton(_ref) {
  let {
    onClick,
    href,
    text,
    ...props
  } = _ref;
  const openExternalPageInNewTab = e => {
    // Prevent default anchor navigation so we can add security flags.
    e.preventDefault();
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
    }

    // Preserve any caller-supplied onClick.
    onClick && onClick(e);
  };
  return /*#__PURE__*/React.createElement(Button, _extends({
    type: "submit",
    onClick: openExternalPageInNewTab,
    "data-testid": "external_link_button",
    href: href,
    icon: "launch",
    target: "_blank",
    rel: "noopener noreferrer",
    iconPosition: "right"
  }, props), text);
}